/* eslint no-undef: 0 */
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { ActivationCodesRepository, MeRepository } from 'common/repositories/index';

/**
 * Controller for the support page embedded in the dashboard
 */

angular.module('controllers')
    .controller('Support', ($scope, $state, Util, $http, $rootScope, $filter) => {

        const activationCodes = ActivationCodesRepository.getAll() || [];
        const { freeSupport } = CWCONFIG.partnerConfig.support;
        const currentLanguage = CWCONFIG.language;

        let redirectLanguage = '';
        if (currentLanguage === 'en') {

            redirectLanguage = 'en-us';

        } else {

            redirectLanguage = currentLanguage;

        }

        // redirect user if doesn't have any licenses
        if (activationCodes.length === 0) {

            $state.go('root.dashboard.home');
            window.open(freeSupport.replace(/\[language\]/gi, redirectLanguage), '_blank');

        }

        const supportedLanguages = CWCONFIG.partnerConfig.support.languages;
        const supportedEmailLanguages = CWCONFIG.partnerConfig.support.emailLanguages;
        const { businessProducts } = CWCONFIG.store;
        const { emailSupport } = CWCONFIG.partnerConfig.support;
        const { businessEmailSupport } = CWCONFIG.partnerConfig.support;
        const { phoneSupport } = CWCONFIG.partnerConfig.support;
        const { community } = CWCONFIG.partnerConfig.support;
        $scope.isBusinessAccount = false;
        $scope.isPersonalAccount = true;
        $scope.showEmailSupportInfo = false;
        $scope.showPhoneSupport = false;
        $scope.infoSupportURL = CWCONFIG.partnerConfig.support.infoSupport.replace(/\[language\]/gi, redirectLanguage);
        $scope.businessInfoSupportURL = CWCONFIG.partnerConfig.support.businessInfoSupport.replace(/\[language\]/gi, redirectLanguage);
        $scope.viewActivityURL = CWCONFIG.partnerConfig.support.viewActivity.replace(/\[language\]/gi, redirectLanguage);
        $scope.currentSection = 'personal';

        $scope.updatecurrentSection = (section) => {

            $scope.currentSection = section;

        };

        activationCodes.forEach((element) => {

            if (!$scope.isBusinessAccount) {

                if (businessProducts.find(el => el === element.relationships.app.data.id)) {

                    $scope.isBusinessAccount = true;
                    $scope.currentSection = 'business';

                }

            }

        });

        if (supportedLanguages.find(element => element === currentLanguage)) {

            $scope.emailSupportURL = emailSupport.replace(/\[language\]/gi, redirectLanguage);
            $scope.phoneSupportURL = phoneSupport.replace(/\[language\]/gi, redirectLanguage);
            $scope.businessEmailSupportURL = businessEmailSupport.replace(/\[language\]/gi, redirectLanguage);
            $scope.communityURL = community.replace(/\[language\]/gi, redirectLanguage);
            const { phoneSupportEnabled } = CWCONFIG.partnerConfig.support;

            if (phoneSupportEnabled) {

                $scope.showPhoneSupport = true;

            }

        } else {

            $scope.emailSupportURL = emailSupport.replace(/\[language\]/gi, 'en');
            $scope.businessEmailSupportURL = businessEmailSupport.replace(/\[language\]/gi, 'en');
            $scope.communityURL = community.replace(/\[language\]/gi, 'en');

            if ((supportedEmailLanguages.indexOf(currentLanguage)) === -1) {

                $scope.showEmailSupportInfo = true;

            }

        }

        $scope.currentTab = $state.params.tab || 'support';

        Mixpanel.send('ConnectWeb Support Open', {
            Source: 'Direct',
            Tab: $scope.currentTab,
        });

        $scope.sendMixpanelClickEvent = (section) => {

            Mixpanel.send('ConnectWeb Support Click', {
                Source: 'Direct',
                Label: section,
            });

        };

        // Chat support
        const user = MeRepository.getMyUser();
        const userLanguage = Util.deepFind(user, 'attributes.language');
        const { chatSupportEnabled } = CWCONFIG.partnerConfig.support;
        const { chatSupportLanguages } = CWCONFIG.partnerConfig.support;
        const chatDepartments = CWCONFIG.partnerConfig.support.chatDepartmentByLanguage;
        const checkChatLanguage = chatSupportLanguages.find(lang => lang === userLanguage);
        $scope.chatAvailable = false;
        $scope.filterName = $filter('friendName')(user);

        if (checkChatLanguage && chatSupportEnabled && chatDepartments) {

            $scope.showChatSupport = true;
            $scope.chatWidgetIsLoading = true;

            const chatScriptUrl = 'https://static.zdassets.com/ekr/snippet.js?key=e574cc8f-ee6b-4fa8-ac52-e9ed8324d299';

            const loadScript = (url, callback) => {

                const scriptTag = document.createElement('script');
                angular.element('body').append(scriptTag);
                scriptTag.onload = () => {

                    callback();

                };

                scriptTag.src = url;
                scriptTag.id = 'ze-snippet';

            };

            loadScript(chatScriptUrl, () => {

                $http({

                    method: 'GET',
                    url: 'https://support-surveys.avira.com/chat/agents_online',

                }).then((data) => {

                    $scope.language = CWCONFIG.language;
                    setTimeout(() => {

                        $scope.departmentKey = chatDepartments[$scope.language];

                        if ($scope.departmentKey in data.data &&
                            data.data[$scope.departmentKey] > 0) {

                            if (window.$zopim) {

                                $scope.checkLibraryLoaded();

                            } else {

                                $scope.triggerChatClickInterval =
                                    setInterval($scope.checkLibraryLoadedInterval, 1000);

                            }

                        } else {

                            window.zE('webWidget', 'hide');
                            $scope.chatAvailable = false;
                            $scope.chatWidgetIsLoading = false;
                            $scope.$apply();

                        }

                    }, 1000);


                }).catch(() => {

                    $scope.chatWidgetIsLoading = false;
                    $scope.chatAvailable = false;

                });

            });

            $scope.openChat = () => {

                if (!$rootScope.chatIsOpened && $scope.chatAvailable) {

                    $scope.sendMixpanelClickEvent('Chat support');

                    $scope.chatWidgetIsLoading = true;
                    $scope.chatAvailable = false;

                    $scope.triggerChatClickInterval =
                        setInterval($scope.triggerChatClick, 2000);

                    window.zESettings = {
                        webWidget: {
                            offset: { horizontal: '40px', vertical: '60px' },
                        },
                    };

                }

            };

            $scope.triggerChatClick = () => {

                const chatButtonIframe = angular.element('#launcher');

                if (chatButtonIframe) {

                    angular.element('#launcher').css('display', 'block');
                    const chatButton = chatButtonIframe.contents().find('.wrapper-3hgZT');
                    chatButton.trigger('click');
                    $scope.chatWidgetIsLoading = false;
                    $rootScope.chatIsOpened = true;
                    $scope.$apply();
                    clearInterval($scope.triggerChatClickInterval);

                    if (window.zE) {

                        window.zE('webWidget', 'prefill', {

                            name: { value: $scope.filterName, readOnly: true },
                            email: { value: Util.deepFind(user, 'attributes.email'), readOnly: true },

                        });

                    }

                    $scope.chatAvailable = false;

                }

            };

            $scope.checkLibraryLoaded = () => {

                window.$zopim.livechat.setLanguage($scope.language);
                window.$zopim.livechat.departments.filter('');
                // window.$zopim.livechat.departments.setVisitorDepartment($scope.departmentKey);
                window.$zopim.livechat.departments.setVisitorDepartment($scope.departmentKey);
                $scope.chatAvailable = true;
                $scope.chatWidgetIsLoading = false;
                $scope.$apply();

                if ($scope.checkLibraryLoadedInterval) {

                    clearInterval($scope.checkLibraryLoadedInterval);

                }

            };

        }

    });



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/support/support.js